import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { TextField, FormGroup, Checkbox, FormLabel, FormControlLabel, Button } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleName, roleInfo, ADD, EDIT, VIEW } from '../../../common/common';
import { deduplicationObjArr } from '../../../common/utils';
import Toast from '../../Layout/components/Toast';

const Root = styled(Box)({
    width: '801px',
    backgroundColor: '#ffffff',
    padding: '24px',
    '& .pageTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .title': {
        color: '#212C31',
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: '19px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '15px 0',
    },
    '& .textField': {
        width: '46%',
        marginRight: '30px',
    },
    '& .workWapper': {
        fontSize: '14px',
        margin: '10px 0',
    },
    '& .iconTextField': {
        width: '46%',
        marginRight: '30px',
        display: 'inline-flex',
        '& .icon': {
            fontSize: '20px',
            marginRight: '10px',
        },
        '& .rateText': {
            width: '30%',
            marginRight: '10px',
        },
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
});

const ADMIN = "admin";
class UserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalDOTData: [],
            officeData: [],
            departmentsData: [],
            teamsData: [],
            selectedDate: new Date(),

            first_name: "",
            last_name: "",
            username: "",
            password: "",
            email: "",
            phone: "",
            teamsStr: "",//用户的全部team名字
            rate: 300,
            salary: "",
            position: "",
            inTeams: [],

            roleData: [],
            roleDataClone: [],
            isMine: false,

            btnName: this.btnName(this.props.state),

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const { title, state } = this.props;
        const {
            username,
            password,

            first_name,
            last_name,
            email,
            phone,

            position,

            selectedDate,
            rate,
            salary,
            inTeams,

            roleData,
            isMine,

            btnName,

            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const officeDeptTeam = () => {
            if (state !== ADD) {
                return <div className="workWapper">
                    {inTeams.map((option, index) => (
                        <div key={index}>
                            {this.teamFromat(option)}
                        </div>
                    ))}
                </div>
            }
        }
        const passwordView = () => {
            if (roleName === ADMIN && state === ADD) {
                return <TextField
                    required
                    disabled={this.isDisabled()}
                    id="password"
                    label="Password"
                    type="password"
                    className="textField"
                    margin="dense"
                    variant="outlined"
                    onChange={e => this.handleChange(e, "password")}
                    value={password}
                />
            }
        }
        const roleInfo = () => {
            if (roleName === ADMIN) {
                return <div>
                    <FormLabel component="legend">Choose role</FormLabel>
                    <FormGroup aria-label="position" name="position" row>
                        {roleData.map(row => (
                            <FormControlLabel key={row.id}
                                control={
                                    <Checkbox
                                        disabled={this.isDisabled()}
                                        checked={row.check}
                                        onChange={e => this.handleCheckBox(e, row.id)}
                                        value={row.id}
                                        color="primary"
                                    />
                                }
                                label={row.value}
                            />
                        ))}
                    </FormGroup>
                </div>
            }
        }
        const salaryInfo = () => {
            if (roleName === ADMIN) {
                return <div className="iconTextField h h-c">
                    <span className="icon">$</span>
                    <TextField
                        disabled={this.isDisabled()}
                        id="rate"
                        label="Hour rate"
                        className="rateText"
                        margin="dense"
                        variant="outlined"
                        onChange={e => this.handleChange(e, "rate")}
                        value={rate}
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        id="salary"
                        label="SALARY AMOUNT"
                        className="f"
                        margin="dense"
                        variant="outlined"
                        onChange={e => this.handleChange(e, "salary")}
                        value={salary}
                    />
                </div>
            }
        }
        const hireDateView = () => {
            // console.log(id === roleInfo.identity.id)
            if (roleName === ADMIN || isMine) {
                return <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disabled={this.isDisabled()}
                        className="textField"
                        margin="dense"
                        id="mui-pickers-date"
                        label="Hire date"
                        value={selectedDate}
                        onChange={this.handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            }
        }
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{btnName}</Button>
            }
        }
        const titleView = () => {
            if (roleName === ADMIN) {
                return <div className="title">Work Info</div>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{title}</div>
                <div className="line"></div>
                <form noValidate autoComplete="off">
                    <div className="title">Account</div>
                    <div>
                        <TextField
                            required
                            disabled={this.isDisabled()}
                            id="username"
                            label="Username"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "username")}
                            value={username}
                        />
                        {passwordView()}
                    </div>
                    <div className="title">Personal Info</div>
                    <div>
                        <TextField
                            disabled={this.isDisabled()}
                            id="first-name"
                            label="First name"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "first_name")}
                            value={first_name}
                        />
                        <TextField
                            disabled={this.isDisabled()}
                            id="last-name"
                            label="Last name"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "last_name")}
                            value={last_name}
                        />
                        <TextField
                            required
                            disabled={this.isDisabled()}
                            id="email"
                            label="Email Address"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "email")}
                            value={email}
                        />
                        <TextField
                            disabled={this.isDisabled()}
                            id="phone"
                            label="Phone Number"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "phone")}
                            value={phone}
                        />
                    </div>
                    {titleView()}
                    <div>
                        <TextField
                            required
                            disabled={this.isDisabled()}
                            id="position"
                            label="Position"
                            className="textField"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, "position")}
                            value={position}
                        />
                        <div className="textField"></div>
                        {officeDeptTeam()}
                        {hireDateView()}
                        {salaryInfo()}
                        {roleInfo()}
                    </div>
                </form>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        if (roleName === ADMIN) {
            this.getRole(() => {
                this.initAdminData();
            });
        } else {
            this.initUserData();
        }
    }
    initAdminData() {
        const { data, state } = this.props;
        console.log(data)
        console.log("=======", roleInfo)
        if (state === VIEW || state === EDIT) {
            const username = data.username ? data.username : "";
            const email = data.email ? data.email : "";
            const first_name = data.first_name ? data.first_name : "";
            const last_name = data.last_name ? data.last_name : "";
            const phone = data.phone ? data.phone : "";
            const rate = data.rate ? data.rate : "";
            const salary = data.salary ? data.salary : "";
            const position = data.position ? data.position : "";
            const teams = data.roles;
            const selectedDate = new Date(data.hire_date);
            this.extRole(teams);
            this.setState(() => ({
                username,
                email,
                first_name,
                last_name,
                phone,
                selectedDate,
                rate,
                salary,
                position,
                inTeams: teams ? teams : []
            }))
        }
    }
    initUserData() {
        const { data } = this.props;
        console.log(data.position)
        const username = data.username ? data.username : "";
        const email = data.email ? data.email : "";
        const first_name = data.first_name ? data.first_name : "";
        const last_name = data.last_name ? data.last_name : "";
        const phone = data.phone ? data.phone : "";
        const rate = data.rate ? data.rate : "";
        const salary = data.salary ? data.salary : "";
        const teams = data.roles;
        const position = data.position ? data.position : "";
        const selectedDate = new Date(data.hire_date);
        const teamsStr = this.getTeamsName(teams);
        let isMine = false;
        if (data.id === roleInfo.identity.id) {
            isMine = true
        }
        this.extRole(teams);
        this.setState(() => ({
            username,
            email,
            first_name,
            last_name,
            phone,
            rate,
            salary,
            selectedDate,
            teamsStr,
            position,
            inTeams: teams ? teams : [],
            isMine
        }))
    }
    handleCreate() {
        const {
            username,
            password,
            first_name,
            last_name,
            email,
            phone,
            rate,
            salary,
            position,
            selectedDate,
        } = this.state;
        const hire_date = (Date.parse(selectedDate) / 1000).toString(),
            isAdd = this.props.state === ADD;
        if (!username || !email || !position || (isAdd && !password)) {
            this.showToast("Please fill in the information with *", "warning");
            return;
        }
        const roleData = this.extChangeRole();
        console.log(roleData);
        let obj = {
            username,
            first_name,
            last_name,
            email,
            phone,
            position,
            hire_date,//时间戳
            rate: parseFloat(rate),
            salary: parseFloat(salary),
            roleData
        };

        if (isAdd) {
            obj['password'] = password;
        }
        this.props.handleCreate(obj);
    }
    extChangeRole() {
        const { roleData, roleDataClone } = this.state;
        console.log(roleData, roleDataClone);
        let roleArr = [];
        for (const obj of roleData) {
            for (const cloneObj of roleDataClone) {
                if (obj.id === cloneObj.id) {
                    if (obj.check !== cloneObj.check) {
                        roleArr.push(obj);
                    }
                }
            }
        }
        return roleArr;
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //textfield输入
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    //选择日期
    handleDateChange(date) {
        this.setState(() => ({
            selectedDate: date
        }))
    }
    //checkbox
    handleCheckBox(e, id) {
        const { roleData } = this.state;
        let temporaryObj = roleData;
        for (const key in temporaryObj) {
            if (temporaryObj[key].id === id) {
                temporaryObj[key].check = !temporaryObj[key].check;
            }
        }
        this.setState(() => ({
            roleData: temporaryObj
        }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    //对象数组过滤出相同的obj
    filterObjArr(objArr, key, name) {
        let newObjArr = [];
        for (const obj of objArr) {
            if (obj[key] === name) {
                newObjArr.push(obj);
            }
        }
        return newObjArr
    }
    getTeamsName(teams) {
        let teamsStr = "";
        if (teams) {
            if (teams.length > 0) {
                const arr = deduplicationObjArr(teams, "name");
                for (const obj of arr) {
                    if (arr.indexOf(obj) === arr.length - 1) {
                        teamsStr += obj.name;
                    } else {
                        teamsStr += obj.name + " , ";
                    }
                }
            }
        }
        return teamsStr;
    }
    changeRoleName(roleId) {
        if (roleId === 1) {
            return "admin";
        } else if (roleId === 2) {
            return "dept manager";
        } else if (roleId === 3) {
            return "team leader";
        } else if (roleId === 4) {
            return "billing manager";
        } else if (roleId === 5) {
            return "client manager";
        } else if (roleId === 6) {
            return "staff";
        } else {
            return "";
        }
    }
    teamFromat(roleObj) {
        const deptObj = roleObj.department;
        const teamObj = roleObj.team;
        const roleId = roleObj.role.id;
        if (deptObj) {
            return deptObj.office + " - " + deptObj.name + " (" + this.changeRoleName(roleId) + ")";
        } else if (teamObj) {
            return teamObj.dept.office + " - " + teamObj.dept.name + " - " + teamObj.name + " (" + this.changeRoleName(roleId) + ")";
        } else {
            return "";
        }
    }
    extRole(roles) {
        const { roleData } = this.state;
        if (!roles) return;
        for (const roleObj of roleData) {
            for (const obj of roles) {
                if (roleObj.id === obj.role.id) {
                    roleObj.check = true;
                }
            }
        }
        const roleDataClone = this.clone(roleData);
        this.setState(() => ({
            roleData,
            roleDataClone
        }));
    }
    clone(origin) {
        return JSON.parse(JSON.stringify(origin));
    }
    //-------------request------------
    getRole(callback) {
        instance.get(BASE_URL + 'admin/roles').then((res) => {
            const dataArr = res.data.data;
            let roleData = [];
            for (const key in dataArr) {
                let obj = {};
                obj.id = dataArr[key].id;
                obj.check = false;
                obj.value = dataArr[key].name;

                if (obj.id === 5 || obj.id === 4 || obj.id === 1) {
                    roleData.push(obj);
                }
            }
            const roleDataClone = this.clone(roleData);
            this.setState({
                roleData,
                roleDataClone
            }, () => {
                callback()
            });
        })
    }
    getTeams(dept_id, callback = null) {
        const params = {
            dept_id
        }
        instance.get(BASE_URL + 'admin/teams', { params }).then((res) => {
            const teamsData = res.data.data;
            this.setState({
                teamsData
            }, () => {
                if (callback) callback();
            });
        })
    }
}

export default UserInfo;